module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-noneheader"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("意见反馈")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("反馈列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "80%"
    }
  }, [_c('div', {
    staticClass: "search-div"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "是否处理"
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, _vm._l((_vm.selectOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.typeValue),
      callback: function($$v) {
        _vm.typeValue = $$v
      },
      expression: "typeValue"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "button-pull-right",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dt.data,
      "stripe": true,
      "border": "",
      "highlight-current-row": "",
      "size": _vm.dt.size
    },
    on: {
      "sort-change": _vm.dt.handleSortChange,
      "selection-change": _vm.dt.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "5%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "id",
      "label": "ID",
      "min-width": "5%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "user.name",
      "label": "用户",
      "min-width": "10%",
      "show-overflow-tooltip": true,
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "food.name",
      "label": "食物",
      "min-width": "10%",
      "show-overflow-tooltip": true,
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "content",
      "label": "内容",
      "min-width": "30%",
      "show-overflow-tooltip": true,
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型",
      "min-width": "10%",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.type === 1 ? 'primary' : scope.row.type === 2 ? 'info' : 'success',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(scope.row.type == 1 ? '功能建议' : scope.row.type === 2 ? '产品bug' : scope.row.type === 4 ? '食物报错' : '其他问题') + "\n                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "min-width": "10%",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.status == 'UNDISPOSED' ? 'primary' : 'success',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(scope.row.status == 'UNDISPOSED' ? '未处理' : '已处理') + "\n                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary",
            "plain": true
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看\n                ")]), _vm._v(" "), (scope.row.status == 'UNDISPOSED') ? [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning",
            "plain": true
          },
          on: {
            "click": function($event) {
              return _vm.handleStatus(scope.$index, scope.row)
            }
          }
        }, [_vm._v("处理\n                  ")])] : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.dt.currentPage,
      "page-sizes": _vm.dt.pageSizes,
      "page-size": _vm.dt.pageSize,
      "layout": _vm.dt.layout,
      "total": _vm.dt.totalElements
    },
    on: {
      "size-change": _vm.dt.handleSizeChange,
      "current-change": _vm.dt.handleCurrentChange
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9717f4e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/feedback/FeedbackList.vue
// module id = 466
// module chunks = 2